var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "variation-resolver-wrapper" },
    [
      !_vm.value
        ? _c(
            _setup.FormControlTypeNumber,
            _vm._g(
              _vm._b(
                { ref: "input" },
                "FormControlTypeNumber",
                _vm.$props,
                false
              ),
              _vm.$listeners
            )
          )
        : _setup.description
        ? _c(
            "div",
            { staticClass: "p-2 border rounded bg-light text-dark small" },
            _vm._l(_setup.description, function (val, name, index) {
              return _c(
                "div",
                {
                  key: name,
                  class: {
                    "mb-1": index < Object.keys(_setup.description).length - 1,
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "text-muted fw-semibold",
                      staticStyle: { "text-transform": "capitalize" },
                    },
                    [
                      _vm._v(
                        "\n                " + _vm._s(name) + ":\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("span", { staticClass: "ms-1 fw-bold" }, [
                    _vm._v(_vm._s(val)),
                  ]),
                ]
              )
            }),
            0
          )
        : _c("div", { staticClass: "text-muted small italic p-1" }, [
            _c("i", { staticClass: "bi bi-info-circle me-1" }),
            _vm._v(
              "\n        Variation ID #" +
                _vm._s(_vm.value) +
                " (No descriptions saved)\n    "
            ),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }